<template>
  <section class="section-form" id="section-form">
    <div class="form__container">
      <FlipCountdown2 size="small"/>
      <div class="form__item form__item-1">
        <div class="form__navigation">
          <div class="form__navigation__tabs">
            <DropdownButton></DropdownButton>
          </div>
        </div>
      </div>
      <div class="form__item form__item-3">
        <div class="wrapper">
          <GoogleMaps
              tooltipText="Google Maps"
              imageSource="assets/image/svg/google-maps.svg"
              action="#google-maps-popup"
          />
        </div>
        <ImageSlider/>
      </div>
      <div class="form__item form__item-4">
        <div class="form__alert-info">
          <div class="form__alert-info__header">
            <div class="header__text">Alert Info</div>
          </div>
          <div class="form__alert-info__content">
            <form action="#" class="alert-info__form" autocomplete="off">
              <div class="alert-info__form__group">
                <input
                    type="text"
                    class="alert-info__form__input"
                    placeholder="Message ID"
                    id="message-id"
                    :value="messageId"
                    @input="updateMessageId"
                    required
                />
                <label for="message-id" class="alert-info__form__label"
                >Message ID</label
                >
              </div>
              <div class="alert-info__form__group">
                <input
                    type="text"
                    class="alert-info__form__input"
                    placeholder="Sender"
                    id="sender"
                    :value="sender"
                    @input="updateSender"
                    required
                />
                <label for="sender" class="alert-info__form__label"
                >Sender</label
                >
              </div>
              <!-- <div>DODAT TIME SENT</div> -->
              <div class="alert-info__form__radio-group">
                <label class="alert-info__form__radio-label"
                >Message Type</label
                >
                <ul>
                  <RadioButtonGroup :Alerts="[{ name: 'Alert' }, { name: 'Update' }]" @store-value-name="updateMessageType"/>
                </ul>
              </div>
              <div class="alert-info__form__radio-group">
                <label for="message-id" class="alert-info__form__radio-label">Status</label>
                <ul>
                  <RadioButtonGroup :Alerts="[{ name: 'Actual' }, { name: 'Exercise' },{ name: 'System' }, { name: 'Test' },{ name: 'Draft' }]" @store-value-name="updateStatus"/>
                </ul>
              </div>
              <div class="alert-info__form__radio-group">
                <label for="message-id" class="alert-info__form__radio-label">Scope</label>
                <ul>
                  <RadioButtonGroup :Alerts="[{ name: 'Public' }, { name: 'Restricted' },{ name: 'Private' }]" @store-value-name="updateScope"/>
                </ul>
              </div>
            </form>
          </div>
        </div>
        <div class="form__event-info">
          <div class="form__event-info__header">
            <div class="header__text">Event Info</div>
          </div>
          <div class="form__event-info__content">
            <form action="#" class="alert-info__form" autocomplete="off">
              <div class="alert-info__form__group">
                <input
                    type="text"
                    class="alert-info__form__input"
                    placeholder="Event Type"
                    id="event-type"
                    @input="updateEventType"
                    required
                />
                <label for="event-type" class="alert-info__form__label"
                >Event Type</label
                >
              </div>
              <div class="alert-info__form__radio-group">
                <label for="message-id" class="alert-info__form__radio-label"
                >Urgency</label
                >
                <ul>
                  <RadioButtonGroup :Alerts="[{ name: 'Immediate' }, { name: 'Expected' },{ name: 'Future' }, { name: 'Past' },{ name: 'Unknown' }]" @store-value-name="updateUrgency"/>
                </ul>
              </div>
              <div class="alert-info__form__radio-group">
                <label for="message-id" class="alert-info__form__radio-label"
                >Severity</label
                >
                <ul>
                  <RadioButtonGroup :Alerts="[{ name: 'Extreme' }, { name: 'Severe' },{ name: 'Moderate' }, { name: 'Minor' },{ name: 'Unknown' }]" @store-value-name="updateSeverity"/>
                </ul>
              </div>
              <div class="alert-info__form__radio-group">
                <label for="message-id" class="alert-info__form__radio-label"
                >Certainty</label
                >
                <ul>
                  <RadioButtonGroup :Alerts="[{ name: 'Extreme' }, { name: 'Severe' },{ name: 'Moderate' }, { name: 'Minor' },{ name: 'Unknown' }]" @store-value-name="updateCertainty"/>
                </ul>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="form__item form__item-5">
        <div class="form__event-description">
          <div class="form__event-description__header">
            <div class="header__text">Event Description</div>
          </div>
          <div class="form__event-description__content">
            <TextArea @store-value="updateDescription"/>
          </div>
        </div>
        <div class="form__event-instruction">
          <div class="form__event-instruction__header">
            <div class="header__text">Instruction</div>
          </div>
          <div class="form__event-instruction__content">
            <TextArea @store-value="updateInstruction"/>
          </div>
        </div>
      </div>
      <div class="form__item form__item-6">
        <div class="form__submit">
          <ButtonWithTooltip
              buttonText="View Products Description"
              tooltipText="View Products description"
              buttonSize="md"
              animated="false"
              green="true"
              action="#product-popup"
          />
          <ButtonWithTooltip
              buttonText="Review Your Warning Form Before Submitting"
              tooltipText="Review Your Form Before Submitting"
              buttonSize="md"
              animated="false"
              green="true"
              action="#table-popup"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FlipCountdown2 from "../UI/FlipCountdown2.vue";
import GoogleMaps from "../UI/SmallButtonWithTooltip.vue";
import ImageSlider from "../UI/ImageSlider.vue";
import DropdownButton from "@/components/UI/DropdownButton";
import TextArea from "@/components/UI/TextArea";
import RadioButtonGroup from "@/components/UI/RadioButtonGroup";
import ButtonWithTooltip from "@/components/UI/ButtonWithTooltip";
import { mapState } from 'vuex';

export default {
  props: ["isBigClockVisible"],
  components: {
    RadioButtonGroup,
    FlipCountdown2,
    GoogleMaps,
    ImageSlider,
    DropdownButton,
    TextArea,
    ButtonWithTooltip
  },
  data() {
    return {
      chosenNavigation: {},
    };
  },
  computed: {
    ...mapState({
      messageId: state => state.alertForm.alertInfo.messageId,
      sender: state => state.alertForm.alertInfo.sender,
      messageType: state => state.alertForm.alertInfo.messageType,
      status: state => state.alertForm.alertInfo.status,
      scope: state => state.alertForm.alertInfo.scope,
      eventType: state => state.alertForm.eventInfo.eventType,
      urgency: state => state.alertForm.eventInfo.urgency,
      severity: state => state.alertForm.eventInfo.severity,
      certainty: state => state.alertForm.eventInfo.certainty,
      description: state => state.alertForm.eventDescription,
      instruction: state => state.alertForm.instruction
    }),
    _isBigClockVisible() {
      return this.isBigClockVisible;
    },
    getSelectedRegionNavigation() {
      return this.$store.getters.getSelectedRegion.navigation;
    },
  },
  methods: {
    updateMessageId(e) {
      this.$store.commit("updateMessageId", e.target.value)
      console.log("Message id: " + this.messageId)
    },
    updateSender(e) {
      this.$store.commit("updateSender", e.target.value)
      console.log("Sender: " + this.sender)
    },
    updateMessageType(value) {
      console.log("Updating Message Type")
      this.$store.commit("updateMessageType", value)
    },
    updateStatus(value) {
      console.log("Updating Status")
      this.$store.commit("updateStatus", value)
    },
    updateScope(value) {
      console.log("Updating Scope")
      this.$store.commit("updateScope", value)
    },
    updateEventType(e) {
      console.log("Updating EventType")
      this.$store.commit("updateEventType", e.target.value)
    },
    updateUrgency(value) {
      console.log("Updating Urgency")
      this.$store.commit("updateUrgency", value)
    },
    updateSeverity(value) {
      console.log("Updating Severity")
      this.$store.commit("updateSeverity", value)
    },
    updateCertainty(value) {
      console.log("Updating Certainty")
      this.$store.commit("updateCertainty", value)
    },
    updateDescription(value) {
      console.log("Updating description ")
      this.$store.commit("updateDescription", value)
    },
    updateInstruction(value) {
      console.log("Updating instruction")
      this.$store.commit("updateInstruction", value)
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../sass/_variables.scss";
@import "../../sass/_mixins.scss";

.wrapper {
  display: inline-flex;
  position: absolute;
  z-index: 1;
  top: 0.1rem;
  left: 0.05rem;
}

.section-form {
  height: 98.5vh;
  padding: 1rem;
  background-color: $color-grey-light-2;
}

.form__container {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  text-align: center;
  height: 98%;
}

.form__item {
  padding: 0.2rem;
  margin: 0.5rem;
  color: black;
  font-size: 4rem;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 1rem;
  height: 80%;

  &-1 {
    background-color: transparent;
    flex: 0 1 100%;
    height: 15%;
    position: relative;
  }

  &-2 {
    flex: 0 1 5%;
  }

  &-3 {
    position: relative;
    flex: 0 1 41%;
  }

  &-4 {
    background-color: transparent;
    flex: 0 1 22%;
  }

  &-5 {
    background-color: transparent;
    flex: 0 1 22%;
  }

  &-6 {
    position: relative;
    background-color: transparent;
    flex: 0 1 8%;
  }

  &-7 {
    flex: 0 1 100%;
    height: 5%;
    background-color: transparent;
  }
}

.form__navigation {
  display: flex;
  flex-wrap: nowrap;
  height: 100%;

  &-countdown {
    width: 20%;
    height: 100%;
    text-align: initial;
  }

  &__tabs {
    width: 100%;
    height: 100%;

    &--primary {
      @include respond(break1) {
        height: 45%;
      }
    }

    &--secondary {
      @include respond(break1) {
        height: 50%;
      }
    }
  }
}

.form__alert-info {
  width: 100%;
  height: 49%;
  border-radius: 1rem;
  background-color: rgba(255, 255, 255, 0.8);
  margin-bottom: 1.5rem;
  overflow-y: scroll;
  overscroll-behavior: none;
  -ms-overflow-style: none;
  scrollbar-width: none;
  box-shadow: rgba(0, 0, 0, 0.15) 0.195rem 0.195rem 0.26rem;

  &__header {
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: linear-gradient(
            to right bottom,
            $color-tertiary-light,
            $color-tertiary-dark
    );
    height: 12.5%;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
  }

  &__content {
  }
}

.form__alert-info::-webkit-scrollbar {
  display: none; /* for Chrome, Safari, and Opera */
}

.form__event-info {
  width: 100%;
  height: 49%;
  border-radius: 1rem;
  background-color: rgba(255, 255, 255, 0.8);
  box-shadow: rgba(0, 0, 0, 0.15) 0.195rem 0.195rem 0.26rem;
  overflow-y: scroll;
  overscroll-behavior: none;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &__header {
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: linear-gradient(
            to right bottom,
            $color-tertiary-light,
            $color-tertiary-dark
    );
    height: 12.5%;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
  }

  &__content {
  }
}

.form__event-info::-webkit-scrollbar {
  display: none; /* for Chrome, Safari, and Opera */
}

.form__event-description {
  width: 100%;
  height: 49%;
  border-radius: 1rem;
  background-color: rgba(255, 255, 255, 0.8);
  margin-bottom: 1.5rem;
  box-shadow: rgba(0, 0, 0, 0.15) 0.195rem 0.195rem 0.26rem;

  &__header {
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: linear-gradient(
            to right bottom,
            $color-tertiary-light,
            $color-tertiary-dark
    );
    height: 12.5%;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
  }

  &__content {
    height: 87.5%;
  }
}

.form__event-instruction {
  width: 100%;
  height: 49%;
  border-radius: 1rem;
  background-color: rgba(255, 255, 255, 0.8);
  box-shadow: rgba(0, 0, 0, 0.15) 0.195rem 0.195rem 0.26rem;

  &__header {
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: linear-gradient(
            to right bottom,
            $color-tertiary-light,
            $color-tertiary-dark
    );
    height: 12.5%;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
  }

  &__content {
    height: 87.5%;
  }
}

.form__submit {
  position: absolute;
  bottom: 0.5rem;
  right: 3.5rem;
}

ul {
  list-style: none;
  margin-top: 2rem;
}

.alert-info__form {
  &__group {
    font-size: 1.2rem;
  }

  &__group:not(:last-child) {
    margin-bottom: 0.5rem;
  }

  &__input {
    font-size: 1.2rem;
    font-family: inherit;
    color: inherit;
    padding: 1rem 2rem;
    border-radius: 0.2rem;
    background-color: rgba($color-white, 0.7);
    border: none;
    border-bottom: 0.3rem solid transparent;
    box-shadow: rgba(0, 0, 0, 0.15) 0.195rem 0.195rem 0.26rem;
    width: 90%;
    display: block;
    transition: all 0.3s;
    margin-top: 1rem;
    margin-left: 1rem;

    &:focus {
      outline: none;
      box-shadow: 0 1rem 2rem rgba($color-black, 0.2);
      border-bottom: 0.3rem solid $color-primary;
    }

    &:focus:invalid {
      border-bottom: 0.3rem solid $color-secondary-dark;
    }

    &::-webkit-input-placeholder {
      color: $color-grey-dark-2;
    }
  }

  &__label {
    color: $color-grey-dark-2;
    font-size: 1.2rem;
    font-weight: 500;
    margin-top: 0.7rem;
    display: block;
    transition: all 0.3s;
  }

  &__radio-group {
    font-size: 1.2rem;
    padding: .5rem;
    margin: 1rem;
    border: 0.1rem solid $color-grey-light-2;
    border-radius: 1rem;
    background-color: $color-grey-light-2;
    box-shadow: rgba(0, 0, 0, 0.15) 0.195rem 0.195rem 0.26rem;
  }

  &__radio-label {
    font-size: 1.2rem;
    font-weight: 600;
    color: $color-grey-dark-3;
    border-bottom: 0.1rem solid $color-grey-dark-2;
  }

  //+ je sibling selector zato što se u html-u elementi nalaze jedan do drugog
  &__input:placeholder-shown + &__label {
    opacity: 0;
    visibility: hidden;
    transform: translateY(-4rem);
  }
}

.header__text {
  font-size: 1.6rem;
  color: $color-white;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
